import HelloWorld from "./HelloWorld.jsx";

export default {
  HelloWorld,
};
